import React from "react";
import { AssetUploadProps, AssetUploadType } from "./types";
import useAssetUploadService from "./service";
import DefaultAssetUIRenderer from "./defaultAssetUIRenderer";
import DefaultFileAssetUIRenderer from "./defaultFileAssetUiRenderer";

function AssetUpload({ customRenderer, ...props }: AssetUploadProps) {
  const service = useAssetUploadService(props);
  const uploadedAssets = React.useMemo(() => props.uploadedAssets.filter(i => Boolean(i)), [props.uploadedAssets]);

  return React.useMemo(() => {
    if (customRenderer) {
      return (
        <React.Fragment>
          {customRenderer({
            uploadedAssets: uploadedAssets,
            assetUploadType: props.assetUploadType,
            assetConfig: props.assetConfig,
            disabled: props.disabled,
            removeAsset: props.onAssetRemove,
            dropzoneState: service.dropzoneState,
            uploadSelectedAsset: service.uploadSelectedAsset,
            hasError: props.hasError,
            defaultAsset: props.defaultAsset
          })}
        </React.Fragment>
      );
    } else {
      switch (props.assetUploadType) {
        case AssetUploadType.FILE:
          return (
            <DefaultFileAssetUIRenderer
              uploadedAssets={uploadedAssets}
              assetUploadType={props.assetUploadType}
              assetConfig={props.assetConfig}
              disabled={props.disabled}
              removeAsset={props.onAssetRemove}
              dropzoneState={service.dropzoneState}
              uploadSelectedAsset={service.uploadSelectedAsset}
              hasError={props.hasError}
              recommendedCustomCopyKey={props.recommendedCustomCopyKey}
            />
          );
        case AssetUploadType.IMAGE:
        case AssetUploadType.BOTH:
          return (
            <DefaultAssetUIRenderer
              uploadedAssets={uploadedAssets}
              assetUploadType={props.assetUploadType}
              assetConfig={props.assetConfig}
              disabled={props.disabled}
              removeAsset={props.onAssetRemove}
              dropzoneState={service.dropzoneState}
              hasError={props.hasError}
              defaultAsset={props.defaultAsset}
              disableImagePreview={props.disableImagePreview}
              browseUploadCustomCopyKey={props.browseUploadCustomCopyKey}
              recommendedCustomCopy={props.recommendedCustomCopy}
              recommendedCustomCopyKey={props.recommendedCustomCopyKey}
            />
          );
      }
    }
  }, [
    customRenderer,
    service.uploadSelectedAsset,
    props.assetUploadType,
    props.assetConfig,
    props.disabled,
    props.onAssetRemove,
    props.hasError,
    service.dropzoneState,
    uploadedAssets,
    props.defaultAsset,
    props.disableImagePreview,
    props.browseUploadCustomCopyKey,
    props.recommendedCustomCopy,
    props.recommendedCustomCopyKey
  ]);
}

export default AssetUpload;
